import { createApiClient } from "./createApiClient";
import { BASE_URL, EPICENTER_BASE_URL } from "./constants";

const API = new createApiClient(BASE_URL);
const API_EPICENTER = new createApiClient(EPICENTER_BASE_URL);

export { API, API_EPICENTER };
